<template>
  <div class="news-banners-container">
    <v-banner
      v-for="(news, index) in unseenNews"
      :key="news.news_id || index"
      class="news-banner"
      color="secondary"
      outlined
      app
      min-height="64px"
    >
      <div class="news-content">
        <div class="news-title-row">
          <v-icon class="mr-2 info-icon" color="primary"
            >mdi-information</v-icon
          >
          <span class="subtitle-1 my-auto">{{ news.title }}</span>
        </div>
        <div class="body-2 mt-1">
          {{ news.content }}
        </div>
      </div>
      <v-btn icon small class="close-button" @click="closeBanner()">
        <v-icon class="close-icon">mdi-close</v-icon>
      </v-btn>
    </v-banner>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "niko-news",
  computed: {
    ...mapState("authStore", ["newsLastSeen"]),
    ...mapState("newsStore", ["news"]),
    unseenNews() {
      const lastSeen = this.newsLastSeen ? new Date(this.newsLastSeen) : null;
      return this.news.filter((news) => {
        const newsStartDate = new Date(news.date_start);
        return !isNaN(newsStartDate) && (!lastSeen || newsStartDate > lastSeen);
      });
    },
  },
  methods: {
    ...mapActions("authStore", ["setNewsLastSeenAttribute"]),
    closeBanner() {
      this.setNewsLastSeenAttribute();
    },
  },
};
</script>

<style lang="scss">
.news-banners-container {
  .news-banner {
    position: relative !important;

    .v-banner__wrapper {
      padding: 12px 0px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      .v-banner__text {
        width: -webkit-fill-available;
      }
    }

    .close-button {
      position: absolute;
      top: 8px;
      right: 8px;
    }

    .news-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 800px;
      margin: 0 auto;
      text-align: center;
      padding: 0 16px;
    }
    .news-title-row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 4px;
    }
  }
}
</style>
